import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { NewGameForm, newGameFormOpts } from '@/domains/game/form/new-game-form'
import { useAppForm } from '@/lib/form'
import { useGameBlindOptions } from '@/domains/game_blind/queries'
import { validateUserOrThrow } from '@/lib/middleware'
import { useCreateGameMutation } from '@/domains/game/queries'

export const Route = createFileRoute('/game/new')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const { queryClient } = context
    const { accessToken } = validateUserOrThrow(queryClient)

    const gameBlinds = await queryClient.ensureQueryData(
      useGameBlindOptions(accessToken),
    )

    return gameBlinds
  },
})

function RouteComponent() {
  const { mutateAsync: createGame } = useCreateGameMutation()
  const navigate = useNavigate()

  const form = useAppForm({
    ...newGameFormOpts,
    onSubmit: async ({ value }) => {
      const game = await createGame({
        game_type: value.gameVisibility,
        player_limit: parseInt(value.autoStartPlayerCount),
        game_blind_id: value.blindId,
        auto_start_count: Number(value.autoStartPlayerCount),
      })
      navigate({ to: '/game/$id', params: { id: game.id } })
    },
  })

  return (
    <div className="p-4 lg:px-8 lg:flex-1 lg:flex lg:flex-col lg:items-center lg:justify-center">
      <div className="w-full lg:w-fit">
        <h2 className="text-3xl font-medium">Create game</h2>
        <p className="text-muted-foreground mt-1">Adjust your game settings.</p>
        <div className="py-4">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              form.handleSubmit()
            }}
          >
            <NewGameForm form={form} />
          </form>
        </div>
      </div>
    </div>
  )
}
